import { Link } from "@amzn/awsui-components-react-v3";
import React from "react";

export const TeamsPageHelpPanelContent: React.FC = (): JSX.Element => {
  return (
    <React.Fragment>
      <div>
        <p>
          The Crew details tab displays the Team Hierarchy and detailed Team
          information, including team name and team owner.
          <br />
          <br />
          If you have the appropriate access, you can select Edit to change the
          team name or team owner. Learn more about how to perform these actions{" "}
          <Link
            external
            externalIconAriaLabel="Opens in a new tab"
            href="https://w.amazon.com/bin/view/Roster2/Help/Managing_Teams/#HHowdoIassignand2ForupdateaTeamOwner3F"
          >
            here
          </Link>
          . <br />
          <br />
          With the right level access, you can also select the Actions drop
          down, which allows you to Create teams, Move teams or Delete teams.
          Learn more about how to perform these actions{" "}
          <Link
            external
            externalIconAriaLabel="Opens in a new tab"
            href="https://w.amazon.com/bin/view/Roster2/Help/Managing_Teams/"
          >
            here
          </Link>
          .
        </p>
      </div>
    </React.Fragment>
  );
};

export default TeamsPageHelpPanelContent;
